<div class="slider-element">
    <label class="control-label">{{ label }}</label>
    <div class="slider-and-value">
        <div class="slider-row">
            <div class="progress-slider-track" [style.--progress]="progress">
                <input #rangeInput
                type="range" class="progress-slider"
                [min]="min"
                [max]="max"
                [step]="step"
                [value]="value"
                (input)="onInputChange($event)"
                (change)="onCommit($event)"
                logChange
                [id]="id"
                [parent]="parent" />
            </div>
            <div class="slider-values">
                <span class="slider-min">{{ sliderMin }}</span>
                <span class="slider-max">{{ sliderMax }}</span>
            </div>
        </div>
        <div class="slider-value-box">{{ value }}</div>
    </div>
</div>
